var exports = {
  "Z": "xe564cbfb--2a7700--layout",
};

module.exports = exports;
